import BaseApi from './baseApi';
import IListExciseDrinkCategory from '../models/IListExciseDrinkCategory';
import IAuthentication from '../models/IAuthentication';

export default class ListExciseDrinkCategoriesApi extends BaseApi {
    idUser : string = "";
    idCompany : string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetListExciseDrinkCategories() : Promise<IListExciseDrinkCategory[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listExciseDrinkCategories: IListExciseDrinkCategory[] = [];
            listExciseDrinkCategories = response.data as IListExciseDrinkCategory[];
            return listExciseDrinkCategories;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListExciseDrinkCategory(listExciseDrinkCategory: IListExciseDrinkCategory) : Promise<string> {
        const json = this.getJsonSave(listExciseDrinkCategory);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListExciseDrinkCategory(listExciseDrinkCategory: IListExciseDrinkCategory) : Promise<boolean> {
        const json = this.getJsonUpdate(listExciseDrinkCategory);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteListExciseDrinkCategory(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListExciseDrinkCategories",
                "Item2": "id"
            }, {
                "Item1": "ListExciseDrinkCategories",
                "Item2": "name"
            }],
            "tables": [{
                "Item1": "ListExciseDrinkCategories"
            }],
            "conditions": [{
                "Item1": "ListExciseDrinkCategories",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "ListExciseDrinkCategories",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": this.idCompany
            }],
            "orderBy": [{
                "Item1": "ListExciseDrinkCategories.name"
            }]
        };
        return json;
    }
    
    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListExciseDrinkCategories",
            "conditions": [{
                "Item1": "ListExciseDrinkCategories",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(listExciseDrinkCategory: IListExciseDrinkCategory) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listExciseDrinkCategory.name
            }, {
                "Item1": "IdCompany",
                "Item2": this.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListExciseDrinkCategories"
        };
        return json;
    }

    private getJsonUpdate(listExciseDrinkCategory: IListExciseDrinkCategory) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listExciseDrinkCategory.name
            }, {
                "Item1": "IdCompany",
                "Item2": this.idCompany
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListExciseDrinkCategories",
            "keyvalue": listExciseDrinkCategory.id
        };
        return json;
    }
}
